import React from 'react';
import { Link } from "react-router-dom";
import logo from '../image/logo.svg';
import search from '../image/icon/icon-search.png';
import heart from '../image/icon/icon-heart.png';
import '../styles/navBar.scss';

const NavBar = (props) => {
  const { onFilterClick } = props;
  return (
    <div className="navBar">
      <div className="container">
        <div className="row">
          <div className="col-2">
            <div className="icon inverse" style={{ backgroundImage : 'url('+ search +')' }} onClick={onFilterClick}></div>
          </div>
          <div className="col-10">
            <div className="row">
              <div className="col">
                <Link to="/">
                  <div className="icon" style={{ backgroundImage : 'url('+ logo +')' }}></div>
                </Link>
              </div>
              <div className="col">
                <Link to="/search">應援</Link>
              </div>
              <div className="col">
                <Link to="/bookmark">
                  <div className="icon heart inverse" style={{ backgroundImage : 'url('+ heart +')' }}></div>
                </Link>
              </div>
            </div>
          </div>
          <div className="col">
          </div>
        </div>
      </div>
    </div>
  )
}

export default NavBar;
